import React, { PropsWithChildren, ReactElement } from "react";
import styles from "./PriceBox.module.scss";
import { Price } from "../../types/price";

import clsx from "clsx";
import { formatPrice, PriceFromBackground } from "../utils";

type Props = {
  price: Price;
  topLabel?: ReactElement;
  bottomLabel?: ReactElement;
  rightLabel?: ReactElement;
  chipBackgroundColor?: PriceFromBackground;
  priceType?: "primary" | "secondary";
  className?: string;
};

export const PriceBox: React.FC<Props> = ({
  price,
  chipBackgroundColor = "white",
  topLabel,
  bottomLabel,
  rightLabel,
  className,
  priceType = "primary"
}) => {
  return (
    <div className={clsx(styles.priceBox, className)}>
      {topLabel}
      <PriceValue
        price={price}
        chipBackgroundColor={chipBackgroundColor}
        priceType={priceType}
      >
        {rightLabel}
      </PriceValue>
      <div className={styles.bottomDisclaimer}>{bottomLabel}</div>
    </div>
  );
};

type PriceValueProps = {
  price: Price;
  chipBackgroundColor: PriceFromBackground;
  className?: string;
  priceType: "primary" | "secondary";
};

export const PriceValue: React.FC<PropsWithChildren<PriceValueProps>> = ({
  price,
  chipBackgroundColor,
  children,
  className,
  priceType
}) => {
  return (
    <div
      className={clsx(
        styles.priceValue,
        {
          [styles.discounted]: price.type == "discounted",
          [styles.secondary]: priceType == "secondary"
        },
        className
      )}
    >
      {formatPrice(price, chipBackgroundColor)}
      {children}
    </div>
  );
};

type TopLabelProps = {
  className?: string;
  uppercase?: boolean;
};
export const PriceBoxTopLabel: React.FC<PropsWithChildren<TopLabelProps>> = ({
  className,
  uppercase,
  children
}) => {
  return (
    <div
      className={clsx(
        styles.topLabel,
        { [styles.labelUppercase]: uppercase },
        className
      )}
    >
      {children}
    </div>
  );
};

type BottomLabelProps = {
  className?: string;
  uppercase?: boolean;
};
export const PriceBoxBottomLabel: React.FC<
  PropsWithChildren<BottomLabelProps>
> = ({ className, uppercase, children }) => {
  return (
    <div
      className={clsx(
        styles.bottomLabel,
        { [styles.labelUppercase]: uppercase },
        className
      )}
    >
      {children}
    </div>
  );
};
